import React, { Component } from 'react';

import './vistaPrevia.css'

import CabeceraLogo from '../../../img/logocabecera.png';
import CloseLogo from '../../../img/closeLogo.png';
import IconBot from '../../../img/IconBot.png';
import ImgLogo from '../../../img/imgLogo.png';
import EmoticonLogo from '../../../img/emoticonLogo.png';
import EnviarLogo from '../../../img/enviarLogo.png';

import Functions from '../../../functions/Parametrizacion/handleColores'; 

class VistaPrevia extends Component {

    constructor(props){
        super(props);
        this.state = {
            colorBot: '',
            colorCliente: '',
            colorBarra: '',
            colorFondo: '',
            colorTextoBot: '',
            colorTextoCli: '',
        }

        this.setearColores();
    }

    setearColores = async () => {
        const datos = await Functions.GetColoresDefinidos();
        if(datos){
            this.barra.style.background = datos.data.color_desplazamiento;
            this.msjBot.style.background = datos.data.color_bot;
            this.msjBotSegundo.style.background = datos.data.color_bot;
            this.msjUsers.style.background = datos.data.color_cliente;
            this.bodyBox.style.background = datos.data.color_fondo;

            let textosBot = document.getElementsByClassName('textoBot');
            
            if(textosBot){
                for (const itemB of textosBot) {
                    itemB.style.color = datos.data.color_texto_bot;
                }
            }

            let textosCli = document.getElementsByClassName('textoClien');
            if(textosCli){
                textosCli[0].style.color = datos.data.color_texto_cliente;
            }

        }else{
            console.log('no hay datos');
        }
    }

    componentDidUpdate = () => {
        const {coloresNuevos} = this.props;
        let tipoColor = coloresNuevos.tipoColor;

        switch (tipoColor) {
            case 'colorFondo':
                this.bodyBox.style.background = coloresNuevos.color;
                break;

            case 'colorChatbot':
                this.msjBot.style.background = coloresNuevos.color;
                this.msjBotSegundo.style.background = coloresNuevos.color;
                break;
            
            case 'colorCliente':
                this.msjUsers.style.background = coloresNuevos.color;
                break;

            case 'colorBarra':
                this.barra.style.background = coloresNuevos.color;
                break;

            case 'colorTextoBot':
                let textosBot = document.getElementsByClassName('textoBot');
                if(textosBot){
                    for (const item of textosBot) {
                        item.style.color = coloresNuevos.color;
                    }
                }
                break;
            
            case 'colorTextoCli':
                let textosCli = document.getElementsByClassName('textoClien');
                if(textosCli){
                    textosCli[0].style.color = coloresNuevos.color;
                }
                break;

            default:
                console.log('no se pueden actualizar los colroes');
                break;
        }
    }
    
    render(){
        return(
            <div className='col s12 m4 x5'>
                <div className='row contenedorVistaPrevia'>
                    <div className='col s12 m12 x12 headVistaPrevia'>
                        <p>Vista Previa</p>
                    </div>
                    <div className='col s12 m12 x12 boxVistaPrevia' ref={element => this.bodyBox = element}>
                        <div className='headBox'>
                            <img src={CabeceraLogo} alt='logoCabecera'/> 
                            <img src={CloseLogo} alt='closeLogo' />
                            <div className='barraScroll' ref={element => this.barra = element}>
                                <p>Últimos mensajes</p>
                            </div>
                        </div>
                        <div className='bodyBox'>
                            <div className='msjChatBot'>
                                <div className='infoHoraBot'>
                                    <p>Pablo Bot</p>
                                    <p>9:38 am</p>
                                </div>
                                <div className='textoMsjBot' ref={element => this.msjBot = element}>
                                    <img src={IconBot} alt='logoBot' />
                                    <p className='textoBot'>¡Bienvenido, soy Pablo! ¿En qué le puedo ayudar?</p>
                                </div>  
                            </div>
                            <div className='msjUsers'>
                                <div className='infoHoraUser'>
                                    <p>Pablito</p>
                                    <p>10:29</p>
                                </div>
                                <div className='textoMsjUsers' ref={element => this.msjUsers = element}>
                                    <p className='textoClien'>¿Qué productos ofrecen?</p>
                                </div>
                            </div>
                            <div className='msjChatBotSegundo'>
                                <div className='infoHoraBot'>
                                    <p>Pablo Bot</p>
                                    <p>9:38 am</p>
                                </div>
                                <div className='textoMsjBot' ref={element => this.msjBotSegundo = element}>
                                    <img src={IconBot} alt='logoBot' />
                                    <p className='textoBot'>Ofrecemos los siguientes tipos de productos:</p>
                                    <ul className='textoBot'>
                                        <li>Producto 1</li>
                                        <li>Producto 2</li>
                                        <li>Producto 3</li>
                                    </ul>
                                    <p className='textoBot'>¿En qué tipo de producto está interesado?</p>
                                </div>  
                            </div>
                        </div>
                        <div className='footBox'>
                            <div className='pabloEscribe'>
                                <p>... Pablo está escribiendo</p>
                            </div>
                            <img className='logoImagenAdd' src={ImgLogo} alt='enviarImg'/>
                            <div className='escribirMensaje'>
                                <img src={EmoticonLogo} alt='emoticon'/>
                                <p>Habla con Pablo</p>
                                <img src={EnviarLogo} alt='enviar' />
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        );
    }
}

export default VistaPrevia;